import {
  FormControl,
  FormField,
  FormItem,
  FormMessage,
} from "@common/components/ui/form"
import {
  InputOTP,
  InputOTPGroup,
  InputOTPSlot,
} from "@common/components/ui/input-otp"
import { REGEXP_ONLY_DIGITS } from "input-otp"
import type { ControllerRenderProps, FieldValues, Path } from "react-hook-form"
import { useFormContext } from "react-hook-form"

export function renderPinInput<T extends FieldValues>({
  field,
  length,
  autoFocus,
}: {
  field: ControllerRenderProps<T, Path<T>>
  length: number
  autoFocus?: boolean
}): React.ReactElement {
  const slots = Array.from({ length }, (_, slot) => slot)
  return (
    <InputOTP
      maxLength={length}
      pattern={REGEXP_ONLY_DIGITS}
      inputMode="numeric"
      autoComplete="off"
      autoFocus={autoFocus}
      {...field}
      value={String(field.value ?? "")}
    >
      <InputOTPGroup>
        {slots.map((slot) => (
          <InputOTPSlot key={slot} index={slot} masked />
        ))}
      </InputOTPGroup>
    </InputOTP>
  )
}

export function BarePinField<T extends FieldValues>({
  name,
  label,
  length,
  autoFocus,
}: {
  name: Path<T>
  label: string
  length: number
  autoFocus?: boolean
}): React.ReactElement {
  const { control } = useFormContext<T>()
  return (
    <FormField
      control={control}
      name={name}
      render={({ field }) => (
        <FormItem className="flex flex-col items-center">
          <FormControl aria-label={label}>
            {renderPinInput<T>({ field, length, autoFocus })}
          </FormControl>
          <FormMessage />
        </FormItem>
      )}
    />
  )
}
